<script>
export default {
  name: 'UlHeaderTabs',
  props: {
    value: String,
    items: {
      type: Array,
      default: () => ([]),
    },
    route: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    click(item) {
      this.$emit('input', item.value);
      if (this.route && item.value !== this.value) {
        this.$router.push(item.to);
      }
    },
  },
};
</script>
<template>
  <div
    v-if="items.length"
    class="ul-header-tabs"
  >
    <div
      class="ul-header-tabs__item"
      v-for="item in items"
      :key="item.value"
      :class="{'is-active': item.value === value}"
      @click="click(item)"
    >
      {{item.label|lang}}
    </div>
  </div>
</template>
<style lang="scss">
  .ul-header-tabs {
    width: 100%;
    display: flex;
    padding: 0 54px;

    &__item {
      height: 42px;
      font-size: 0.875rem;
      font-weight: 500;
      min-width: 100px;
      text-align: center;
      line-height: 40px;
      text-transform: uppercase;
      padding: 0 16px;
      cursor: pointer;
      position: relative;

      &.is-active {
        color: #1b2f3f;

        &:before {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 3px;
          background: #1b2f3f;
        }
      }

      &:hover {
        background-color: rgba(158, 158, 158, .2);
      }

      &:active {
        background-color: rgba(158, 158, 158, .4);
      }

      &:focus {
        background-color: rgba(0, 0, 0, .12);
      }
    }
  }
</style>
